import {
  UPDATE_COURSE_STUDENT_EVENT_DATA,
  UPDATE_ZOOM_COURSE_TYPE,
  ZOOM_COURSE_UPLOAD_REQUEST,
  ZOOM_COURSE_UPLOAD_SUCCESS,
  LOAD_COURSE_USER_DATA_START,
  LOAD_COURSE_USER_DATA,
  LOAD_COURSE_USER_DATA_SUCCESS,
  UPDATE_SELECTED_COURSE_USER_DETAILS
} from '../constants/action-types'

const defaultState = {
  isSingleCourse: true,
  courseId: '',
  courseIds: [],
  requestedBy: '',
  users: { data: [], loading: true },
  data: [],
  withGroups: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOAD_COURSE_USER_DATA_START: {
      return {
        ...state,
        ...{ users: { data: [...state.users.data], loading: action.loading } }
      }
    }

    case UPDATE_SELECTED_COURSE_USER_DETAILS: {
      return {
        ...state,
        data: action.payload
      }
    }

    case LOAD_COURSE_USER_DATA_SUCCESS: {
      // let termIds = state.selectedTerms.data.map( terms => terms.id );

      let dataAlreadySaved = state.users.data

      if (dataAlreadySaved.length === 0) {
        return {
          ...state,
          ...{
            users: {
              data: [...state.users.data.concat(action.payload)],
              loading: action.loading
            }
          }
        }
      } else {
        return {
          ...state,
          ...{
            users: {
              data: [...state.users.data.concat(action.payload)],
              loading: action.loading
            }
          }
        }
      }
    }

    case UPDATE_COURSE_STUDENT_EVENT_DATA: {
      return {
        ...state,

        courseId: action.payload.courseId,
        courseIds: action.payload.courseIds,
        requestedBy: action.payload.requestedBy,
        daysCount: action.payload.daysCount,
        users: action.payload.users,
        data: action.payload.data,
        withGroups: action.payload.withGroups
      }
    }

    case UPDATE_ZOOM_COURSE_TYPE: {
      return {
        ...state,
        isSingleCourse: action.payload
      }
    }

    case ZOOM_COURSE_UPLOAD_REQUEST: {
      return {
        ...state,
        uploadS3DataLoading: action.payload
      }
    }

    case ZOOM_COURSE_UPLOAD_SUCCESS: {
      return {
        ...state,
        uploadS3DataLoading: false,
        uploadedDataResult: action.payload
      }
    }

    default:
      return state
  }
}
